import { render, staticRenderFns } from "./pricePrePortList.vue?vue&type=template&id=2063e282&scoped=true&"
import script from "./pricePrePortList.vue?vue&type=script&lang=js&"
export * from "./pricePrePortList.vue?vue&type=script&lang=js&"
import style0 from "./pricePrePortList.vue?vue&type=style&index=0&id=2063e282&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2063e282",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2063e282')) {
      api.createRecord('2063e282', component.options)
    } else {
      api.reload('2063e282', component.options)
    }
    module.hot.accept("./pricePrePortList.vue?vue&type=template&id=2063e282&scoped=true&", function () {
      api.rerender('2063e282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Price/pricePrePortList.vue"
export default component.exports